// extracted by mini-css-extract-plugin
export var accent = "_ax-4";
export var add = "_ax-j";
export var addIcon = "_ax-k";
export var deleteIcon = "_ax-i";
export var disabled = "_ax-9";
export var ellipsis = "_ax-f";
export var error = "_ax-3";
export var form = "_ax-5";
export var hideFocus = "_ax-2";
export var icon = "_ax-7";
export var input = "_ax-e";
export var listItem = "_ax-h";
export var mediumHeight = "_ax-b";
export var noBorder = "_ax-8";
export var noRadius = "_ax-1";
export var shortHeight = "_ax-a";
export var tallHeight = "_ax-c";
export var textInput = "_ax-0";
export var vertical = "_ax-g";
export var veryTallHeight = "_ax-d";
export var widget = "_ax-6";